import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useState } from 'react';
import { InputStatus } from '../../../models/error.model';
import { IUserService } from '../../user/user.service';
import { ChangePasswordModal } from '../components/ChangePasswordModal';

interface IProps {
  showModal: boolean;
  userId: string;
  onClose: () => void;
}

export const ChangePasswordContainer = observer((props: IProps): ReactElement => {
  const userService = useInjection(IUserService.$);

  const [password, setPassword] = useState('');
  const [passwordScore, setPasswordScore] = useState(0);
  const [passwordStatus, setPasswordStatus] = useState(InputStatus.empty());

  useEffect(() => {
    setPassword('');
  }, [props.showModal]);

  const handlePasswordChange = (password: string, score: number): void => {
    setPassword(password);
    setPasswordScore(score);
  };

  const handleSave = async (): Promise<void> => {
    await userService.adminChangePassword(props.userId, password);
    props.onClose();
  };

  return (
    <ChangePasswordModal
      show={props.showModal}
      onClose={props.onClose}
      onChange={handlePasswordChange}
      onSave={handleSave}
      passwordStatus={passwordStatus}
      passwordScore={passwordScore}
      onPasswordStatusChange={setPasswordStatus}
    />
  );
});
